import { Shell } from "../shared";
import { useReader } from "../ReaderContext";

export const ContentsPage = ({ page }) => {
  const { goTo } = useReader();
  const thumbs = (page.toc || []).filter((t) => t.image).slice(0, 4);
  return (
    <Shell page={page}>
      <div className="absolute left-11 right-11" style={{ top: 64 }}>
        <div className="text-center">
          <h2 className="mag-head uppercase" style={{ fontSize: 50, color: "var(--bordeaux)" }}>{page.title}</h2>
          <p className="mag-deck mt-1">{page.deck}</p>
        </div>
        <div className="silver-rule-solid mt-5" />
        <div className="grid mt-6" style={{ gridTemplateColumns: "190px 1fr", gap: 26 }}>
          <div className="flex flex-col gap-3">
            {thumbs.map((t) => (
              <button key={t.page} className="relative text-left" style={{ height: 118, overflow: "hidden" }} onClick={() => goTo(t.page)} data-testid={`toc-thumb-${t.page}`}>
                <img src={t.image} alt={t.label} className="mag-img" style={{ objectPosition: "50% 25%" }} />
                <span className="absolute bottom-2 left-2 mag-kicker" style={{ color: "#fff", fontSize: 7.5, textShadow: "0 1px 6px rgba(0,0,0,0.6)" }}>{String(t.page).padStart(2, "0")} · {t.label}</span>
              </button>
            ))}
          </div>
          <div>
            {(page.toc || []).map((t) => (
              <button key={t.page} className="toc-row" onClick={() => goTo(t.page)} data-testid={`toc-link-${t.page}`}>
                <span className="toc-num">{String(t.page).padStart(2, "0")}</span>
                <span className="flex-1">
                  <span className="block font-label uppercase" style={{ fontSize: 11.5, letterSpacing: "0.14em" }}>{t.label}</span>
                  <span className="block font-head italic" style={{ fontSize: 13, opacity: 0.7 }}>{t.section}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </Shell>
  );
};
